import jwtDecode from "jwt-decode";
import React from "react";
import { connect } from "react-redux";
import { Redirect, Route } from "react-router-dom";
import { Constant } from "../../config";
import {
  hideMenuDisplayAction,
  initialProfileAction,
  showMenuDisplayAction,
} from "../../store/actions/headerBar";
import NotFound from "../NotFound";
class PrivateRoute extends React.Component {
  whenTokenInvalid = () => {
    localStorage.removeItem(Constant.SessionKey);
    localStorage.removeItem(Constant.MyNameKey);
    this.props.initialProfileAction();
    this.props.hideMenuDisplayAction();
  };

  render() {
    let signIn = (
      <Redirect
        to={{ pathname: "/sign-in", state: { from: this.props.location } }}
      />
    );
    let token = localStorage.getItem(Constant.SessionKey);
    if (!token) {
      this.whenTokenInvalid();
      return signIn;
    }

    let exp = 0;
    try {
      let tmp = jwtDecode(token);
      exp = tmp.exp;
    } catch (err) {
      this.whenTokenInvalid();
      return signIn;
    }

    if (!exp || Date.now() >= exp * 1000) {
      this.whenTokenInvalid();
      return signIn;
    } else {
      this.props.showMenuDisplayAction();
    }

    if (!this.props.canActivate) {
      return <Route component={NotFound} />;
    }

    return <Route {...this.props} />;
  }
}

const mapDispatchToProps = {
  showMenuDisplayAction,
  hideMenuDisplayAction,
  initialProfileAction,
};

export default connect(null, mapDispatchToProps)(PrivateRoute);



// WEBPACK FOOTER //
// ./src/containers/PrivateRoute/index.js